import { Numeric4BoxIcon } from './Numeric4BoxIcon';

/**
 * author: Google
 * id 9C9EEFA4-B764-41CE-A679-3927454AE59A
 * name numeric-4-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-4-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number4BoxIcon = Numeric4BoxIcon;
export default Number4BoxIcon